import { Features } from '@src/contexts/features-context/types';

type GetFeatureListParams = {
  isWhiteLabel: boolean;
  areMemberBenefitsEnabled: boolean;
  npsSurveyCopyAbExperiment: boolean;
  upgradeUpsellEnabled: boolean;
};

export const getFeatureList = ({
  isWhiteLabel,
  areMemberBenefitsEnabled,
  npsSurveyCopyAbExperiment,
  upgradeUpsellEnabled,
}: GetFeatureListParams): Features => ({
  guestAccount: {
    active: !isWhiteLabel,
  },
  memberBenefits: {
    active: areMemberBenefitsEnabled,
  },
  npsSurveyCopyAbExperiment: {
    active: npsSurveyCopyAbExperiment,
  },
  upgradeUpsell: {
    active: upgradeUpsellEnabled,
  },
});
